import PropTypes from "prop-types";
import React, { useRef } from "react";

import {
    SingleSubNavRight,
    TopNavLinkWrapper,
    TopNavLink,
    TopSubNavLink,
} from "~/components/Header/TopHeader";

import { KEYCODE_SPACE } from "~/utilities/helpers";
import { topNavSubNavKeyboardNavigation } from "~/utilities/accessibilityHelpers";
import useOnKeyPress from "~/hooks/useOnKeyPress";

const TopNavLinks = ({
    linkLabel,
    linkUrl,
    subNavigationItems = [],
    index,
    openTopSubnav = null,
    dispatch,
    mobileMenuIsOpen,
}) => {
    const topNavRef = useRef();
    const hasSubitems = subNavigationItems && !!subNavigationItems.length;

    useOnKeyPress(KEYCODE_SPACE, (keyboardEvent) => {
        if (!mobileMenuIsOpen && topNavRef.current) {
            topNavSubNavKeyboardNavigation(
                keyboardEvent,
                topNavRef,
                hasSubitems,
                openTopSubnav,
                `${linkLabel}-${index}`,
                dispatch,
            );
        }
    });

    return (
        <TopNavLinkWrapper
            ref={topNavRef}
            isOpen={openTopSubnav === `${linkLabel}-${index}`}
            onMouseEnter={() =>
                dispatch({
                    type: "HANDLE_MOUSE_ENTER_TOP",
                    id: `${linkLabel}-${index}`,
                    hasSubitems,
                })
            }
            onMouseLeave={() =>
                dispatch({
                    type: "HANDLE_MOUSE_LEAVE",
                    hasSubitems,
                })
            }
        >
            <TopNavLink
                to={linkUrl}
                ariaExpanded={
                    hasSubitems && openTopSubnav === `${linkLabel}-${index}`
                }
                ariaLabel={hasSubitems ? `${linkLabel} submenu` : null}
            >
                {linkLabel}
            </TopNavLink>
            {hasSubitems ? (
                <SingleSubNavRight
                    isOpen={openTopSubnav === `${linkLabel}-${index}`}
                >
                    {subNavigationItems.map(({ linkLabel, linkUrl }, index) => (
                        <TopSubNavLink
                            key={`${index}-${linkLabel}`}
                            to={linkUrl}
                        >
                            {linkLabel}
                        </TopSubNavLink>
                    ))}
                </SingleSubNavRight>
            ) : null}
        </TopNavLinkWrapper>
    );
};

TopNavLinks.propTypes = {
    linkLabel: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    subNavigationItems: PropTypes.arrayOf(
        PropTypes.shape({
            linkUrl: PropTypes.string.isRequired,
            linkLabel: PropTypes.string.isRequired,
        }),
    ),
    index: PropTypes.number.isRequired,
    openTopSubnav: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    mobileMenuIsOpen: PropTypes.bool.isRequired,
};

export default TopNavLinks;
